export default class TextReveal {
  static init() {
    document.addEventListener("transitionrun", TextReveal.onTransitionRun, true);
    document.addEventListener("transitionend", TextReveal.onTransitionEnd, true);
  }

  static onTransitionRun(e) {
    if (e.propertyName !== "transform") return;
    if (!e.target.classList || !e.target.classList.contains("text-reveal-text")) return;
    const label = e.target.closest(".text-reveal-label");
    if (label) label.classList.remove("is-revealed");
  }

  static onTransitionEnd(e) {
    if (e.propertyName !== "transform") return;
    if (!e.target.classList || !e.target.classList.contains("text-reveal-text")) return;
    const label = e.target.closest(".text-reveal-label");
    if (!label) return;
    const t = getComputedStyle(e.target).transform;
    const atRest = t === "none" || /matrix\(1,\s*0,\s*0,\s*1,\s*0,\s*0\)/.test(t);
    label.classList.toggle("is-revealed", !atRest);
  }
}
